import TimeIcon from "app/components/Icons/TimeIcon";
import CustomTooltip from "app/components/Tooltip";
import { EffortEstimatedPopup } from "app/containers/Features/components/EffortEstimatedPopup";
import { selectProjectMemberList } from "app/containers/Features/components/MemberSelection/redux/selector";
import { ITickets } from "app/containers/Features/containers/Boards/containers/Tickets/types";
import { formatEffortShorthand } from "app/containers/Features/helper";
import { EffortEstimatedType } from "app/containers/Features/types";
import { selectUserFormData } from "app/redux/selector";
import React, { FC, useMemo, useState } from "react";
import { useSelector } from "react-redux";

interface CustomProps {
  ticketDetail: ITickets;
  onUpdate: (effortEstimated: EffortEstimatedType) => void;
}

const EffortEstimated: FC<CustomProps> = ({ ticketDetail, onUpdate }) => {
  const { assignedTo, effortEstimated } = ticketDetail;

  // Global States
  const projectMembers = useSelector(selectProjectMemberList);
  const currentUserDetail = useSelector(selectUserFormData);

  const currentEffortEstimated = useMemo(
    () =>
      Array.isArray(effortEstimated)
        ? effortEstimated.find((effort) => effort.memberId === assignedTo)
        : undefined,
    [effortEstimated, assignedTo],
  );
  const formattedEffort = currentEffortEstimated
    ? formatEffortShorthand(
        currentEffortEstimated.effort?.hours,
        currentEffortEstimated.effort?.minutes,
      )
    : "";
  const userId = projectMembers.find(
    (member) => member._id === assignedTo,
  )?.userId;
  const isAssignee = currentUserDetail._id === userId;

  const [menuVisibility, setMenuVisibility] = useState<boolean>(false);

  return (
    <EffortEstimatedPopup
      portalProps={{
        className: "w-auto",
        assigneeHistoryProps: {
          effortEstimated: effortEstimated,
          totalEffortEstimated: ticketDetail?.totalEffortEstimate,
        },
        assigneeId: assignedTo,
        headerProps: {
          assigneeId: assignedTo,
          effortEstimated: effortEstimated,
          onSubmit(payload) {
            onUpdate({
              _id: "",
              isLock: false,
              memberId: assignedTo,
              effort: {
                _id: "",
                ...payload,
              },
            });
          },
        },
      }}
      menuVisibility={menuVisibility}
      onOpenChange={(open) => {
        setMenuVisibility(open);
      }}
    >
      <CustomTooltip
        text="Set efforts estimation"
        className="flex items-center justify-start w-full min-w-0 overflow-hidden p-1.5 hover:bg-white rounded"
        position="left"
      >
        <button
          type="button"
          className="flex items-center gap-1 w-full min-w-0 overflow-hidden"
          disabled={!isAssignee}
        >
          <span className="flex-shrink-0">
            <TimeIcon size={18} />
          </span>
          <span className="text-sm font-normal text-secondary truncate min-w-0">
            {formattedEffort.length > 0
              ? formattedEffort
              : "Enter efforts estimation"}
          </span>
        </button>
      </CustomTooltip>
    </EffortEstimatedPopup>
  );
};

export default EffortEstimated;
